module.exports = __webpack_public_path__ + "assets/img/scroll.8e1cb1b5.png";